import { createAction, props } from '@ngrx/store';
import { PaginationRequest } from 'src/app/models/common/paginationRequest';
import { PartyDTO } from 'src/app/models/Party/partyDTO';
import { CustomerPartyDTO } from 'src/app/models/Party/customerPartyDTO';
import { EmployeePartyDTO } from 'src/app/models/Party/employeePartyDTO';
import { SupplierPartyDTO } from 'src/app/models/Party/supplierPartyDTO';

// Salutations
export const getSalutations = createAction('[Parties] Get All Parties Salutations Action', props<{ pageReq: PaginationRequest }>());
export const loadSalutations = createAction('[Parties] Load All Parties Salutations Action', props<{ response: any[] }>());
export const loadParties = createAction('[Parties] Load All Parties Action', props<{ response: any[] }>());
// Party Generic Type
export const createParty = createAction('[Parties] Create party Action', props<{ party: PartyDTO }>());
export const getParty = createAction('[Parties] Get a Party by code Action', props<{ partyCode: string }>());
export const setParty = createAction('[Parties] Set Party Action', props<{ party: PartyDTO }>());

// Customers Party Type
export const createCustomerParty = createAction('[CustomersParties] Create Customer party Action', props<{ party: CustomerPartyDTO }>());
export const updateCustomerParty = createAction('[CustomersParties] Update Customer party Action', props<{ party: CustomerPartyDTO }>());
export const getCustomerParty = createAction('[CustomersParties] Get a Customer party by code Action', props<{ partyCode: string }>());
export const setCustomerParty = createAction('[CustomersParties] Set Customer party Action', props<{ party: CustomerPartyDTO }>());
export const resetCustomerParty = createAction('[CustomersParties] Reset Customer party Action');
export const getCustomerPartyList = createAction('[CustomersParties] Get All Customer Party List Action',
    props<{ options: any }>()); // paging?: any, filteringArgs?: any, sortingArgs?: any
export const getCustomerPartyListSearch = createAction('[CustomersParties] Get All Customer Party List Search Action',
    props<{ options: any }>());
export const loadCustomerPartyList = createAction('[CustomersParties] Load All Customer Party List Action Action',
    props<{ response: any[] }>());
// Customers Table Configuration Settings
export const getCustomerTableConfig = createAction(
  "[CustomersParties] Get Customer Party Table Configuration Action",
  props<{ options: any }>()
);
export const loadCustomerTableConfig = createAction(
  "[CustomersParties] Load Customer Party Table Configuration Action",
  props<{ response: any[] }>()
);
export const saveCustomerTableConfig = createAction(
  "[CustomersParties] Save Customer Party Table Configuration Action",
  props<{ config: any }>()
);

// Suppliers Party Type
export const createSupplierParty = createAction('[SuppliersParties] Create Supplier party Action', props<{ party: SupplierPartyDTO }>());
export const updateSupplierParty = createAction('[SuppliersParties] Update Supplier party Action', props<{ party: SupplierPartyDTO }>());
export const getSupplierParty = createAction('[SuppliersParties] Get a Supplier party by code Action', props<{ partyCode: string }>());
export const setSupplierParty = createAction('[SuppliersParties] Set Supplier party Action', props<{ party: SupplierPartyDTO }>());
export const getSupplierPartyList = createAction('[SuppliersParties] Get All Suppliers Party List Action',
    props<{ options: any }>()); // paging?: any, filteringArgs?: any, sortingArgs?: any
export const loadSupplierPartyList = createAction('[SuppliersParties] Load All Suppliers Party List Action Action',
    props<{ response: any[] }>());
export const resetSupplierParty = createAction('[SuppliersParties] Reset Supplier party Action');
// Suppliers Table Configuration Settings
export const getSupplierTableConfig = createAction(
  "[SuppliersParties] Get Supplier Party Table Configuration Action",
  props<{ options: any }>()
);
export const loadSupplierTableConfig = createAction(
  "[SuppliersParties] Load Supplier Party Table Configuration Action",
  props<{ response: any[] }>()
);
export const saveSupplierTableConfig = createAction(
  "[SuppliersParties] Save Supplier Party Table Configuration Action",
  props<{ config: any }>()
);

// Employees Party Type
export const createEmployeeParty = createAction('[EmployeesParties] Create Employee party Action', props<{ party: EmployeePartyDTO }>());
export const updateEmployeeParty = createAction('[EmployeesParties] Update Employee party Action', props<{ party: EmployeePartyDTO }>());
export const getEmployeeParty = createAction('[EmployeesParties] Get a Employee party by code Action', props<{ partyCode: string }>());
export const setEmployeeParty = createAction('[EmployeesParties] Set Employee party Action', props<{ party: EmployeePartyDTO }>());
export const getEmployeePartyList = createAction('[EmployeesParties] Get All Employees Party List Action',
    props<{ options: any }>()); // paging?: any, filteringArgs?: any, sortingArgs?: any
export const loadEmployeePartyList = createAction('[EmployeesParties] Load All Employees Party List Action Action',
    props<{ response: any[] }>());
export const resetEmployeeParty = createAction('[EmployeesParties] Reset Employee party Action');
// Employees Table Configuration Settings
export const getEmployeeTableConfig = createAction(
  "[EmployeesParties] Get Employee Party Table Configuration Action",
  props<{ options: any }>()
);
export const loadEmployeeTableConfig = createAction(
  "[EmployeesParties] Load Employee Party Table Configuration Action",
  props<{ response: any[] }>()
);
export const saveEmployeeTableConfig = createAction(
  "[EmployeesParties] Save Employee Party Table Configuration Action",
  props<{ config: any }>()
);

// Countries
export const getCountries = createAction('[Parties] Get All Countries Action', props<{ pageReq: PaginationRequest }>());
export const loadCountries = createAction('[Parties] Load All Countries Action', props<{ response: any[] }>());
// Categories
export const getCategoriesByUsage = createAction('[Parties] Get All Categories by Usage Action',
    props<{ pageReq: PaginationRequest, usageCode: string }>());
export const loadCategoriesByUsage = createAction('[Parties] Load All Categories by Usage Action', props<{ response: any[] }>());
export const getCategories = createAction('[Parties] Get All Categories by Category Code Action', props<{ categoryCode: string }>());
export const loadCategories = createAction('[Parties] Load All Categories by Category Code Action', props<{ response: any[] }>());
export const getCategoryElements = createAction('[Parties] Get All Category Elements by Category Code Action',
    props<{ categoryCode: string }>());
export const loadCategoryElements = createAction('[Parties] Load All Category Elements by Category Code Action',
    props<{ response: any[] }>());
export const getOptionalCategoriesByUsage = createAction('[Parties] Get All OptionalCategories by Usage Action',
    props<{ pageReq: PaginationRequest, usageCode: string }>());
export const loadOptionalCategoriesByUsage = createAction('[Parties] Load All OptionalCategories by Usage Action',
    props<{ response: any[] }>());
// Categories and Properties for the grids
export const getCategoriesForListByUsage = createAction('[Parties] Get All Categories for the List by Usage Action',
    props<{ pageReq: PaginationRequest, usageCode: string }>());
export const loadCategoriesForListByUsage = createAction('[Parties] Load All Categories for the List by Usage Action',
    props<{ response: any[] }>());
export const getPropertiesForListByUsage = createAction('[Parties] Get All Properties for the List by Usage Action',
    props<{ pageReq: PaginationRequest, usageCode: string }>());
export const loadPropertiesForListByUsage = createAction('[Parties] Load All Properties for the List by Usage Action',
    props<{ response: any[] }>());
// Properties
export const getPropertiesByUsage = createAction('[Parties] Get All Properties by Usage Action',
    props<{ pageReq: PaginationRequest, usageCode: string }>());
export const loadPropertiesByUsage = createAction('[Parties] Load All Properties by Usage Action', props<{ response: any[] }>());
export const getOptionalPropertiesByUsage = createAction('[Parties] Get All Optional Properties by Usage Action',
    props<{ pageReq: PaginationRequest, usageCode: string }>());
export const loadOptionalPropertiesByUsage = createAction('[Parties] Load All Optional Properties by Usage Action',
    props<{ response: any[] }>());
// Loading Actions
export const getLoadingState = createAction('[CustomersParties] Get Customer party Loading State Action');
export const setLoadingStartState = createAction('[CustomersParties] Set Customer party Loading Start State Action');
export const setLoadingEndState = createAction('[CustomersParties] Set Customer party Loading End State Action');
// Customer Contracts
export const getCustomerContractsList = createAction('[CustomersParties] Get Customer Contracts List by customer code Action',
props<{ container: any, options: any }>());
export const loadCustomerContractssList = createAction('[CustomerParties] Load All Contracts by Customer id List Action',
    props<{ response: any[] }>());
    export const getCustomerCardsList = createAction('[CustomersParties] Get Customer Cards List by customer code Action',
    props<{ itemCode: string, options: any }>());
    export const getCustomerVehiclesList = createAction('[CustomerParties] Get All Vehicles by Customer id List Action',
    props<{ container: any, options: any }>());
export const loadCustomerVehiclesList = createAction('[CustomerParties] Load All Vehicles by Customer id List Action',
    props<{ response: any[] }>());
    export const getCustomerEmployeesList = createAction('[CustomerParties] Get All Employees by Customer id List Action',
    props<{ container: any, options: any }>());
export const loadCustomerEmployeesList = createAction('[CustomerParties] Load All Employees by Customer id List Action',
    props<{ response: any[] }>());
//Excel Party Customer List
export const getCustomerExcelList = createAction(
    "[CustomerParties] Get All Party Customer Excel List Action",
    props<{ options: any }>()
  );
  export const loadCustomerExcelList = createAction(
    "[CustomerParties] Load All Party Customer Excel List Action",
    props<{ response: any[] }>()
  );
  //Excel Party Employee
  export const getEmployeeExcelList = createAction(
    "[EmployeeParties] Get All Party Employee Excel List Action",
    props<{ options: any }>()
  );
  export const loadEmployeeExcelList = createAction(
    "[EmployeeParties] Load All Party Employee Excel List Action",
    props<{ response: any[] }>()
  );
  //Excel Party Supplier
  export const getSupplierExcelList = createAction(
    "[SupplierParties] Get All Party Supplier Excel List Action",
    props<{ options: any }>()
  );
  export const loadSupplierExcelList = createAction(
    "[SupplierParties] Load All Party Supplier Excel List Action",
    props<{ response: any[] }>()
  );
  export const resetCustomerEmployeesListState = createAction('[EmployeeParties] Reset Customer Employees List State Action');
  export const resetPartyState = createAction('[Parties] Reset Party State Action');
  export const resetCreation = createAction("[Parties] Reset Creation Action");




